import React from 'react'

export default function FindAndReplaceControllerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        #find-and-replace-container {
          padding: 20px;
          border-radius: 7px;
          /*background-color: rgba(33, 120, 200, 0.8);*/
          /*color: whitesmoke;*/
        }

        #find-and-replace-container .pospro-action-btn {
          padding: 10px;
        }

        .acl-container {
          font-size: 17px; /* force fix */
          position: relative;
          margin-bottom: 10px;
        }

        #form-group-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          color: whitesmoke;
        }

        #find-and-replace-button-container {
          display: flex;
          justify-content: center;
          margin-top: 10px;
        }

        .result-container {
          color: whitesmoke;
          font-size: 0.7em;
          /*background-color: lightgrey;
          border-radius: 7px;*/
          padding: 5px;
        }

        .form-group {
          display: flex;
          flex-direction: column;
          margin: 20px 0;
          padding: 20px;
          width: 60%;
          border-radius: 7px;
        }

        #brand-container {
          background-color: rgba(33, 20, 100, 0.8);
        }

        #name-container {
          background-color: rgba(33, 20, 100, 0.7);
        }

        #description-container {
          background-color: rgba(33, 20, 100, 0.6);
        }

        #classification-container {
          background-color: rgba(33, 20, 100, 0.5);
        }

        .form-group input[type='text'] {
          padding: 5px;
          font-size: 0.8em;
          border-radius: 3px;
          border: solid 1px lightblue;
          margin-top: 5px;
          /*margin-bottom: 10px;*/
          background-color: whitesmoke;
        }
      `}
      </style>
    </React.Fragment>
  )
}
